import { Link } from "react-router-dom";
import { ArrowLeft, Compass } from "lucide-react";
import BrainLogo from "@/components/BrainLogo";
import Seo from "@/components/Seo";
import LegalLinks from "@/components/LegalLinks";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0A0A0B] text-[#F4F4F5] flex flex-col mesh-bg" data-testid="not-found-page">
      <Seo title="Page not found" description="This page doesn't exist on Studivault." path="/404" />
      <header className="px-5 md:px-8 py-4">
        <Link to="/" className="flex items-center gap-2.5 w-fit" data-testid="not-found-logo-link">
          <BrainLogo size={26} />
          <span className="font-semibold tracking-tight">Studivault</span>
        </Link>
      </header>
      <main className="flex-1 flex items-center px-5 md:px-8">
        <div className="max-w-[560px] mx-auto md:mx-0 md:ml-[12vw]">
          <div className="eyebrow mb-3">Error 404</div>
          <h1 className="display-2 mb-4">This page wandered off.</h1>
          <p className="text-[15px] text-[#B0AEBC] mb-8">
            The link may be broken or the page may have moved. Let's get you back to studying.
          </p>
          <div className="flex flex-wrap gap-3">
            <Link to="/" className="btn btn-primary" data-testid="not-found-home-btn"><ArrowLeft size={15} /> Back home</Link>
            <Link to="/explore" className="btn btn-secondary" data-testid="not-found-explore-btn"><Compass size={15} /> Explore packs</Link>
          </div>
        </div>
      </main>
      <footer className="border-t border-white/5 px-5 md:px-8 py-6 text-[12px] text-[#8E8B99]">
        <LegalLinks />
      </footer>
    </div>
  );
}
